// 登录等接口已对接后端
export const USE_MOCK = false;

function resolveWsUrl() {
    if (typeof window === 'undefined') {
        return 'ws://127.0.0.1:8585';
    }

    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.hostname}:8585`;
}

export const WS_URL = resolveWsUrl();
